<script>
export default {
  data() {
    return {};
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    classStyle: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div :class="classStyle">
    <label for="input-text">{{ label }}</label>
    <input
      name="input-text"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.decorate {
  display: flex;
  flex-direction: column;

  label {
    align-self: start;
    font-family: $secondary-font-family;
    font-size: 16px;
    color: gray;
    margin-bottom: 16px;
  }

  input {
    width: auto;
    height: 8.93%;
    font-family: $secondary-font-family;
    font-size: 26px;
    color: #4059e1;
    line-height: 1;
    padding: 1.31% 5% 3.12% 0.5%;
    background: transparent;
    border: none;
    border-block-end: 1px solid rgba(0, 0, 0, 0.3);
    outline: transparent;
  }
}

.simple {
  display: flex;
  flex-direction: column;

  label {
    align-self: start;
    font-family: 'Proxima Nova SemiBold';
    font-size: 12px;
    color: #000000;
    margin-bottom: 1.5%;
  }

  input {
    width: auto;
    height: auto;
    font-family: 'Proxima Nova Light';
    font-size: 16px;
    color: #000000;
    line-height: 1;
    padding: 14.5px 2px 14px 20px;
    background: #f3f3f3;
    border: none;
    border-radius: 8px;
    outline: transparent;
  }
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000000;
  opacity: 0.35;
  font-family: Proxima Nova;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 1;
}
</style>
